import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vant from 'vant'
import 'vant/lib/index.css'
import router from './router'
import utils from './utils/utils'
import contentData from './config/content'
import './utils/rem'

// 引入多语言设置
import i18n from '@/utils/languages/index.js';

import Vue from 'vue'
import App from './App.vue'

//全局注册
Vue.use(ElementUI)
Vue.use(Vant)

Vue.prototype.$utils = utils
Vue.prototype._contentData = contentData

Vue.config.productionTip = false  //生产环境

new Vue({
  el: '#app',
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
